export default __webpack_public_path__ + "autoTest1.388a7f32.png";